import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { merge, Observable, of } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import { normalizeNodeId } from '@gt/_helpers/node-id.util';
import { deleteCacheWithPrefix, getOrCreateCachedObservable } from '../utils/para-http-cache.util';
import { ParaApiRootService } from './para-api-root.service';
import { ParaProgressReportService } from './para-progress-report.service';

@Injectable({ providedIn: 'root' })
export class ParaRosterService {
	private readonly studentsByCacheKey = new Map<string, Observable<unknown>>();

	constructor(
		private readonly http: HttpClient,
		private readonly paraApi: ParaApiRootService,
		private readonly paraProgressReport: ParaProgressReportService
	) {
		this.paraProgressReport.paraProgressTableRefresh$.subscribe((nodeId) => {
			deleteCacheWithPrefix(this.studentsByCacheKey, String(nodeId));
		});
	}

	/** GET {@code /para/progress/students/nodeId/:id}. */
	getStudents$(nodeId: number, assessmentId?: string | null): Observable<unknown> {
		const id = normalizeNodeId(nodeId);
		if (id == null) {
			return of(null);
		}
		const aid = (assessmentId || '').trim();
		const cacheKey = aid ? `${id}::${aid}` : String(id);
		return getOrCreateCachedObservable(this.studentsByCacheKey, cacheKey, () => {
			let params = new HttpParams();
			if (aid) {
				params = params.set('assessmentId', aid);
			}
			return this.http.get<unknown>(this.paraApi.progressUrl(`students/nodeId/${id}`), { params });
		});
	}

	/** GET {@code /para/roster/studentsPerChallenge/nodeId/:id}. */
	getStudentsPerChallenge$(nodeId: number): Observable<unknown> {
		const id = normalizeNodeId(nodeId);
		if (id == null) {
			return of(null);
		}
		return this.http.get<unknown>(this.paraApi.rosterUrl(`studentsPerChallenge/nodeId/${id}`));
	}
}
